export enum ClientCreationEnum {
  Create = 'create',
  EditDraft = 'editDraft',
  Edit = 'edit',
  EditImport = 'editImport',
}
